import { ref } from 'vue';

const COLORBLIND_FRIENDLY_STORAGE_KEY = 'overpassPlanner.colorblindFriendly';

function readStoredPreference(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(COLORBLIND_FRIENDLY_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export const isColorblindFriendly = ref(readStoredPreference());

function applyAccessibilityClass(): void {
  if (typeof document === 'undefined') return;
  document.documentElement.classList.toggle(
    'colorblind-friendly',
    isColorblindFriendly.value,
  );
}

applyAccessibilityClass();

export function setColorblindFriendly(enabled: boolean): void {
  isColorblindFriendly.value = enabled;
  try {
    window.localStorage.setItem(COLORBLIND_FRIENDLY_STORAGE_KEY, String(enabled));
  } catch {
    // Ignore storage errors; the preference still applies for this session.
  }
  applyAccessibilityClass();
}

export function useAccessibilitySettings() {
  return {
    isColorblindFriendly,
    setColorblindFriendly,
  };
}
